// import ajax from '@js/ajax';
import axios from 'axios';
import { createError, getQueryString } from '@js/utils';
import { styleType, isSmallRedBook } from './constants';
import { feedsErrorCode } from '@/config/const.js';
import { getAccessByType } from './access';
import { BrowserBridgeHandler } from './browserBridgeHandler';
import { getHeaderKKUA } from '@js/native';
import { getResourceId, getDocId } from '@js/utils-feeds';

import request from './request';

const { post } = request;

function getBasicParams() {
  const docInfo = window.pageData.DOCINFO;
  return {
    f: 'json',
    docId: docInfo.docId,
  };
}

function createFetch(api, params, headers) {
  const url = getAccessByType('feedsAccess') + api;

  return axios({
    url: url,
    method: 'get',
    timeOut: 15000,
    params,
    headers,
  })
    .then((res) => {
      let data;
      let error;
      res = res.data;
      switch (res.code) {
        case 0:
          data = res.data;
          break;
        case undefined:
          data = res.articles;
          break;

        default:
          if (feedsErrorCode[res.code]) {
            error = createError(res.code, feedsErrorCode[res.code]);
          } else {
            error = createError(
              res.code || -1,
              res.msg || res.message || res.desc || 'unknown mistake',
            );
          }
          break;
      }
      return error ? Promise.reject(error) : data;
    })
    .catch((error) => {
      // console.log(`%c>>Request ${url} get error ${error.code}(${error.message})`, 'color: red;')
      return Promise.reject(new Error(error.message));
    });
}

export function fetchRelatedNews(data = {}, headers) {
  const params = Object.assign(
    {
      num: isSmallRedBook ? 3 : 5,
      count: isSmallRedBook ? 3 : 5,
      session: BrowserBridgeHandler.getBtoaSession(),
    },
    getBasicParams(),
    data,
  );
  if (!params.docId) {
    return Promise.reject('require docId');
  }
  return createFetch('feedsList/getRelativeRecList', params, headers);
}

export function fetchArticleInfo() {
  return axios({
    method: 'post',
    url: getAccessByType('middleAccess') + 'resource/issued/resource',
    data: {
      appId: 1,
      idList: [getResourceId()],
    },
  });
}

export function articlethumbup(params = {}) {
  const { sourceVal } = window.store;
  params = Object.assign(params, {
    docid: getResourceId(),
    source: sourceVal,
    session:
      window.btoa(JSON.stringify(BrowserBridgeHandler.getSession())) || '',
    type: 'smile',
    f: 'json',
  });
  // console.log('articlethumbup',params)
  if (!params.docid) {
    return Promise.reject('require docId');
  }
  return axios({
    baseURL: getAccessByType('feedsAccess'),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
    },
    url: 'feedsInteract/mood',
    params,
  });
}

//三方文章点赞/取消赞/查询点赞状态/查询点赞数直接使用中台数据
const articlesThumbupAccess = getAccessByType('likeAccess');
const articlesThumbApi = {
  queryThumbupCount: post('comment/queryThumbupCount', articlesThumbupAccess),
  thumbup: post('comment/thumbup', articlesThumbupAccess),
  thumbupCancel: post('comment/thumbupCancel', articlesThumbupAccess),
  queryBatchThumbups: post('comment/queryBatchThumbups', articlesThumbupAccess),
};

const baseThumbParams = {
  businessType: 'FEEDS',
  docId: getDocId() || getResourceId(),
  source: 'OPPO',
};

export function queryThumbupCount() {
  const { sourceVal } = window.store;
  baseThumbParams.source = sourceVal;

  const params = Object.assign(
    { feedssession: BrowserBridgeHandler.getIflowSession() },
    baseThumbParams,
  );
  return articlesThumbApi.queryThumbupCount(params);
}

export function queryBatchThumbups() {
  const { businessType, docId: docIds } = baseThumbParams;
  const { sourceVal } = window.store;
  return articlesThumbApi.queryBatchThumbups({
    businessType,
    docIds,
    source: sourceVal,
    feedssession: BrowserBridgeHandler.getIflowSession(),
  });
}

//未入库的三方文章查询点赞数和用户点赞状态
export function queryArticleThumbupsInfoInThird() {
  const countPromise = queryThumbupCount()
    .then((response) => {
      return Number(response) || 0;
    })
    .catch((err) => {
      console.log(err);
      return 0;
    });
  const statusPromise = queryBatchThumbups()
    .then((response) => {
      return response[getDocId()] || false;
    })
    .catch((err) => {
      console.log(err);
      return false;
    });
  return Promise.all([countPromise, statusPromise]);
}
export function articlethumbupThird(data) {
  const { sourceVal } = window.store;
  baseThumbParams.source = sourceVal;
  const params = Object.assign(
    { feedssession: BrowserBridgeHandler.getIflowSession() },
    baseThumbParams,
  );
  // 当前状态是up，对应需要取消点赞
  if (data.operation === 'up') {
    return articlesThumbApi.thumbupCancel(params);
  } else {
    return articlesThumbApi.thumbup(params);
  }
}

// 获取游戏数据
export async function getGameResource(params, data) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    ...(await getHeaderKKUA()),
  };
  let androidAPI;
  if (process.env.NODE_ENV === 'development') {
    androidAPI = 30;
  } else {
    androidAPI = (await BrowserBridgeHandler.getBrowserInfo())
      .androidApiVersion;
  }
  const { sourceVal } = window.store;
  const baseParam = {
    scene: 2, // 场景id,0-沉浸视频列表，1-视频详情页，2-图文详情页
    feedsSession: BrowserBridgeHandler.getIflowSession(),
    session: BrowserBridgeHandler.getBtoaSession(),
    f: 'json',
    source: sourceVal,
    androidAPI,
  };

  return axios({
    url: getAccessByType('feedsAccess') + 'v1/distribution/gameResource',
    method: 'post',
    headers,
    params: { ...baseParam, ...params },
    data,
  })
    .then((res) => {
      let gameResourceData;
      let error;
      let resData = res.data;
      switch (resData.ret) {
        case 0:
          gameResourceData = resData.gameResourceList[0];
          break;
        default:
          error = createError(
            resData.ret || -1,
            resData.msg || resData.message || resData.desc || 'unknown mistake',
          );
          break;
      }
      return error ? Promise.reject(error) : gameResourceData;
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}

// 预约/取消预约
export async function orderOrCancel(type, data) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    ...(await getHeaderKKUA()),
  };
  const url = `${getAccessByType(
    'gameSubscriptionAccess',
  )}v1/distribution/gameSubscription/${type}`;
  const reqBody = new URLSearchParams();
  reqBody.append('appId', JSON.stringify(data.appId));
  reqBody.append('pkg', data.pkg);
  reqBody.append('feedssession', BrowserBridgeHandler.getIflowSession());
  reqBody.append('session', BrowserBridgeHandler.getBtoaSession());
  reqBody.append('enterMod', data.enterMod);

  return axios({
    url,
    method: 'post',
    headers,
    data: reqBody,
  })
    .then((res) => {
      let error;
      let resData = res.data;
      switch (resData.ret) {
        case 200:
          break;
        default:
          error = createError(
            resData.ret || -1,
            resData.msg || resData.message || resData.desc || 'unknown mistake',
          );
          break;
      }
      return error ? Promise.reject(error) : resData.data;
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}

// 获取相关推荐
export async function fetchGetRelatedSearch(params) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    ...(await getHeaderKKUA()),
  };
  return axios({
    headers,
    method: 'get',
    url: getAccessByType('relatedSearcAccess') + 'v1/search/browser/relsearch',
    params,
  });
}

export async function fetchEventCardInfo(params) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    ...(await getHeaderKKUA()),
  };
  return axios({
    headers,
    method: 'get',
    url: getAccessByType('eventCardAccess') + 'v1/distribution/eventResource',
    params,
  });
}

// 不喜欢 反馈接口
export async function postDislike(_data = {}, _params = {}) {
  const { sourceVal } = window.store;
  const docInfo = window.pageData.DOCINFO;
  const data = {
    docid: docInfo.docId,
    session: BrowserBridgeHandler.getBtoaSession(),
    statisticsName: '',
    reason: '',
    styleType: styleType,
    dataType: '',
    source: sourceVal,
    statisticsid: '',
    category: '',
    version: 44,
    channel_id: '',
    ..._data,
  };

  const params = {
    feedsSession: BrowserBridgeHandler.getIflowSession(),
    session: BrowserBridgeHandler.getBtoaSession(),
    feedsBizType: 1,
    f: 'json',
    ..._params,
  };

  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    ...(await getHeaderKKUA()),
  };

  return axios({
    headers,
    method: 'post',
    url: getAccessByType('dislikeAccess') + 'feedsInteract/dislike',
    params,
    data: getQueryString(data),
  }).then((res) => {
    if (res.data !== true) {
      return Promise.reject(res.data);
    }
    return res.data;
  });
}
